import React, { useState } from 'react';
import config from '../../config';
import '../../styles/modal.css';

const DemoModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    businessName: '',
    phoneNumber: '',
    businessType: '',
    branches: '1'
  });
  const [submitted, setSubmitted] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate API call for now. Could be hooked to a backend endpoint later.
    console.log('Demo request submitted:', formData);
    setSubmitted(true);
  };

  const phoneNumber = config.support.phone || '+254726642205';
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^\d+]/g, '')}?text=Hello%20Harvyq,%20I%20just%20submitted%20a%20demo%20request%20for%20${encodeURIComponent(formData.businessName)}.%20I'd%20like%20to%20proceed%20with%20the%20demo.`;

  return (
    <div className="modal-backdrop demo-modal-backdrop" onClick={onClose}>
      <div className="modal-content demo-modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close modal">✕</button>
        
        {!submitted ? (
          <div className="demo-form-container">
            <h2>Book Your Free Demo</h2>
            <p>See exactly how Harvyq works for your business. Fill out the form below and we'll arrange a personalized walkthrough.</p>
            
            <form onSubmit={handleSubmit} className="demo-form">
              <div className="form-group">
                <label htmlFor="fullName">Full Name</label>
                <input type="text" id="fullName" name="fullName" required value={formData.fullName} onChange={handleChange} placeholder="John Doe" />
              </div>
              
              <div className="form-group">
                <label htmlFor="businessName">Business Name</label>
                <input type="text" id="businessName" name="businessName" required value={formData.businessName} onChange={handleChange} placeholder="My Hardware Shop" />
              </div>
              
              <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number</label>
                <input type="tel" id="phoneNumber" name="phoneNumber" required value={formData.phoneNumber} onChange={handleChange} placeholder="07XX XXX XXX" />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="businessType">Business Type</label>
                  <select id="businessType" name="businessType" required value={formData.businessType} onChange={handleChange}>
                    <option value="">Select type...</option>
                    <option value="Hardware">Hardware Store</option>
                    <option value="Wholesale">Wholesale / Distributor</option>
                    <option value="Retail">Retail Shop / Minimart</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Agrovet">Agrovet</option>
                    <option value="Spare Parts">Auto Spare Parts</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="branches">Branches</label>
                  <select id="branches" name="branches" value={formData.branches} onChange={handleChange}>
                    <option value="1">1</option>
                    <option value="2-3">2 - 3</option>
                    <option value="4-10">4 - 10</option>
                    <option value="10+">More than 10</option>
                  </select>
                </div>
              </div>
              
              <button type="submit" className="btn-primary w-100" data-conversion="demo-submit">Book My Free Demo</button>
            </form>
          </div>
        ) : (
          <div className="demo-success-container">
            <div className="success-icon">✓</div>
            <h2>Demo Request Received!</h2>
            <p>Thank you, {formData.fullName}. We've received your details for {formData.businessName}.</p>
            <p>One of our product experts will contact you shortly to schedule your personalized demo.</p>
            <div className="success-actions">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
                Talk to us on WhatsApp Now
              </a>
              <button onClick={onClose} className="btn-secondary">Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DemoModal;
